import MergeDirectory from './MergeDirectory';
export default MergeDirectory;